export const dynamics = [
  {
    id: "dyn-1",
    date: "10.12",
    text: "《潮汐之间》杀青，一人分饰母女两角",
    newsId: "chaoxi-shaqing",
  },
  {
    id: "dyn-2",
    date: "09.28",
    text: "《暗巷回声》获年度影评人推荐",
    newsId: "anxiang-yingping",
  },
  {
    id: "dyn-3",
    date: "09.15",
    text: "出任第 26 届亚洲电影展推广大使",
    newsId: "dianyingzhan-dashi",
  },
  {
    id: "dyn-4",
    date: "08.30",
    text: "年代剧《长夜将明》已开机",
    newsId: "changye-kaiji",
  },
  {
    id: "dyn-5",
    date: "08.08",
    text: "海边特别放映会，朗读三十七封信",
    newsId: "shanhai-fanying",
  },
  {
    id: "dyn-6",
    date: "06.25",
    text: "完成三个月自由潜水训练",
    newsId: "qianshui-xunlian",
  },
];